import { useSelector as useSelectorBase } from 'react-redux';
import { IGlobalState } from './modules/IGlobalState';

/**
 * Use strongly typed selectors.
 */
export function useSelector<T>(select: (state: IGlobalState) => T): T {
  return useSelectorBase<IGlobalState, T>(select);
}
